<div class="internal-notes-container" [formGroup]="formGroup">
  <div class="internal-notes-info" [ngClass]="{ 'is-isf': isIsf }" [style.width]="infoWidth + '%'" *ngIf="isShowDetails && !!item">
    <div class="internal-notes-container-info-col">
      <div class="internal-notes-info-col-header">{{ (isIsf ? "LABELS.EEZYIMPORT_NUM" : "LABELS.EEZY_ID") | translate }}</div>
      <div class="internal-notes-info-col-value">{{ item.referenceNumber }}</div>
    </div>

    <div class="internal-notes-container-info-col" *ngIf="!!item.transactionNumber || !!item.entryNumber">
      <div class="internal-notes-info-col-header">{{ "LABELS.CBP_NUM" | translate }}</div>
      <div class="internal-notes-info-col-value">{{ isIsf ? item.transactionNumber : item.entryNumber }}</div>
    </div>

    <div class="internal-notes-container-info-col" *ngIf="!isIsf && !!item.sentToProviderDate">
      <div class="internal-notes-info-col-header">{{ "STATUS_ES.SENT_TO_CBP" | translate }}</div>
      <div class="internal-notes-info-col-value">{{ item.sentToProviderDate | customDateByUtc }}</div>
    </div>

    <div class="internal-notes-container-info-col" *ngIf="isIsf && !!item.receivedByCbpDate">
      <div class="internal-notes-info-col-header">{{ "STATUS.SECOND_TEXT.RECEIVED_BY_CBP" | translate }}</div>
      <div class="internal-notes-info-col-value">{{ item.receivedByCbpDate | customDateByUtc }}</div>
    </div>
  </div>

  <span class="internal-notes-container__description">{{ "LABELS.INTERNAL_NOTES_MODAL_DESCRIPTION" | translate }}</span>
  <span class="internal-notes-container__label">{{ "LABELS.ALL_FIELDS_OPTIONAL" | translate }}</span>
  <app-control-wrapper
    class="internal-notes-container__ref"
    [control]="formGroup.get('internalReferenceNumber')"
    [helper]="'FORM_HELPER.INTERNAL_NOTES_REF' | translate"
  >
    <label for="refNumber" control-label>{{ "FORM_LABEL.INTERNAL_REF" | translate }}</label>
    <input
      type="text"
      control-wrapper
      id="refNumber"
      name="refNumber"
      class="form-control"
      [formControl]="formGroup.get('internalReferenceNumber')"
      [dropSpecialCharacters]="false"
      [patterns]="CUSTOM_MASK"
      [mask]="'F{50}'"
      [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
      [maxMaskLength]="50"
    />
  </app-control-wrapper>
  <div class="internal-notes-container__text-editor">
    <label for="notes">{{ "LABELS.NOTES" | translate }}</label>
    <textarea type="text" class="form-control" id="notes" name="notes" rows="9" formControlName="internalNotes" control-wrapper></textarea>
    <!--        TODO: UNCOMMENT AFTER #7822-->
    <!--    <text-editor id="notes" [fc]="formGroup.get('internalNotes')"></text-editor>-->
  </div>
  <div class="col-12 pl-0 pr-0">
    <div class="internal-notes-container__clean-form" (click)="clearForm()">
      <i class="fa fa-trash"></i>
      {{ "FORM_LABEL.CLEAR_FORM" | translate }}
    </div>
  </div>
  <div class="internal-notes-container__save">
    <button class="btn btn-primary" (click)="save()">{{ "BUTTON.SAVE" | translate }}</button>
  </div>
</div>
